const WISHLIST_KEY = 'ind_wishlist';

const i18n = window.wishlistI18n || {
  empty: 'Deine Wunschliste ist leer.',
  shopNow: 'Jetzt shoppen',
  loading: 'Wunschliste wird geladen…',
  remove: 'Von Wunschliste entfernen',
  add: 'Zur Wunschliste hinzufügen',
  addToCart: 'In den Warenkorb',
  chooseSize: 'Größe wählen',
  pleaseChooseSize: 'Bitte wähle eine Größe.',
  close: 'Schließen'
};

const Wishlist = {
  getAll() {
    try {
      const items = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return items.map(item => typeof item === 'string'
        ? { handle: item, variantId: null, variantHandle: null }
        : { variantHandle: null, ...item });
    } catch { return []; }
  },

  save(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: items.map(i => i.handle) } }));
  },

  add(handle, variantId, variantHandle) {
    const list = this.getAll();
    const vid = variantId || null;
    const vhandle = variantHandle || null;
    const exists = vid
      ? list.some(item => item.handle === handle && item.variantId === vid)
      : list.some(item => item.handle === handle && !item.variantId);
    if (!exists) this.save([...list, { handle, variantId: vid, variantHandle: vhandle }]);
  },

  remove(handle, variantId) {
    const vid = variantId || null;
    if (vid) {
      this.save(this.getAll().filter(item => !(item.handle === handle && item.variantId === vid)));
    } else {
      this.save(this.getAll().filter(item => item.handle !== handle));
    }
  },

  toggle(handle, variantId, variantHandle) {
    this.has(handle, variantId) ? this.remove(handle, variantId) : this.add(handle, variantId, variantHandle);
  },

  has(handle, variantId) {
    const items = this.getAll();
    if (variantId) return items.some(item => item.handle === handle && item.variantId === variantId);
    return items.some(item => item.handle === handle);
  },

  count() {
    return this.getAll().length;
  },

  getItem(handle) {
    return this.getAll().find(item => item.handle === handle) || null;
  }
};

function updateCountBubbles() {
  const count = Wishlist.count();
  document.querySelectorAll('[data-wishlist-count]').forEach(bubble => {
    const numEl = bubble.querySelector('[aria-hidden]');
    if (numEl) numEl.textContent = count;
    bubble.hidden = count === 0;
  });
}

function updateButtonState(btn) {
  const handle = btn.dataset.wishlistToggle;
  const variantId = getVariantIdForButton(btn);
  const active = Wishlist.has(handle, variantId);
  btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  btn.classList.toggle('is-active', active);
  btn.setAttribute('aria-label', active ? i18n.remove : i18n.add);
}

function getVariantIdForButton(btn) {
  // Wishlist page card: explicit variant attribute set during render
  if (btn.dataset.wishlistVariantId) return parseInt(btn.dataset.wishlistVariantId) || null;
  // In a product card (listing): read the checked color swatch input
  const card = btn.closest('product-card');
  if (card) {
    const checked = card.querySelector('input[type="radio"][data-variant-id]:checked');
    if (checked) return parseInt(checked.dataset.variantId) || null;
  }
  // On the product detail page: read the active variant from the product form
  const input = document.querySelector('product-form input[name="id"], form[is="product-form"] input[name="id"]');
  return input ? (parseInt(input.value) || null) : null;
}

// For combined listings: extract the product handle of the checked swatch's product
function getVariantProductHandle(btn) {
  const card = btn.closest('product-card');
  if (card) {
    const checked = card.querySelector('input[type="radio"][data-variant-id]:checked');
    if (checked && checked.dataset.productUrl) {
      const match = checked.dataset.productUrl.match(/\/products\/([^?#/]+)/);
      return match ? match[1] : null;
    }
  }
  return null;
}

function initWishlistButtons() {
  document.querySelectorAll('[data-wishlist-toggle]').forEach(updateButtonState);
}

// Event delegation for wishlist toggle — survives product-rerender DOM swaps
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn) return;
  e.preventDefault();
  const variantHandle = getVariantProductHandle(btn);
  Wishlist.toggle(btn.dataset.wishlistToggle, getVariantIdForButton(btn), variantHandle);
});

// Re-sync button states after variant selection replaces the quantity-selector block
document.addEventListener('variant:change', () => {
  document.querySelectorAll('[data-wishlist-toggle]').forEach(updateButtonState);
});

// Update wishlist button state when a color swatch is changed in a product card
document.addEventListener('change', e => {
  const input = e.target.closest('product-card input[type="radio"][data-variant-id]');
  if (!input) return;
  const card = input.closest('product-card');
  if (!card) return;
  const btn = card.querySelector('[data-wishlist-toggle]');
  if (btn) updateButtonState(btn);
});

document.addEventListener('wishlist:updated', () => {
  document.querySelectorAll('[data-wishlist-toggle]').forEach(updateButtonState);
  updateCountBubbles();
  if (document.querySelector('[data-wishlist-page]')) renderWishlistPage();
});

// ---- Wishlist page rendering ----

function heartSvg(size) {
  return `<svg role="presentation" fill="none" stroke="currentColor" stroke-width="1.8" focusable="false" width="${size}" height="${size}" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5c-.2 0-.4-.1-.6-.2-2.1-1.3-4-2.8-5.7-4.5-1.8-1.8-2.7-3.6-2.7-5.6 0-3.2 2.3-5.5 5.3-5.5 1.6 0 3.1.7 4.1 1.9 1-1.2 2.5-1.9 4.1-1.9 3 0 5.3 2.3 5.3 5.5 0 2-.9 3.8-2.7 5.6-1.7 1.7-3.6 3.2-5.7 4.5-.1.1-.3.2-.4.2Z" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
}

function formatMoney(cents) {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
}

async function fetchProduct(handle) {
  try {
    const res = await fetch(`${Shopify.routes.root}products/${handle}.js`);
    if (!res.ok) return null;
    return await res.json();
  } catch { return null; }
}

function getCartIconSvg(size = 20) {
  // Clone from header to match the configured icon style (shopping_basket / tote_bag / shopping_cart)
  const countEl = document.querySelector('.header__cart-count');
  if (countEl) {
    let el = countEl.previousElementSibling;
    while (el) {
      if (el.tagName.toLowerCase() === 'svg') {
        const clone = el.cloneNode(true);
        clone.setAttribute('width', size);
        clone.setAttribute('height', size);
        clone.removeAttribute('class');
        return clone.outerHTML;
      }
      el = el.previousElementSibling;
    }
  }
  // Fallback: shopping_basket
  return `<svg role="presentation" fill="none" stroke-width="1.5" focusable="false" width="${size}" height="${size}" viewBox="0 0 22 22" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 7H3.577A2 2 0 0 0 1.64 9.497l2.051 8A2 2 0 0 0 5.63 19H16.37a2 2 0 0 0 1.937-1.503l2.052-8A2 2 0 0 0 18.422 7H11Zm0 0V1"/></svg>`;
}

const COLOR_LABELS = ['farbe', 'color', 'colour', 'couleur', 'kleur'];
const SIZE_LABELS = ['größe', 'grösse', 'size', 'gr.', 'taille', 'talla'];

function localizeOption(name) {
  if (!name) return '';
  const lower = name.toLowerCase();
  if (COLOR_LABELS.includes(lower)) return i18n.colorLabel || name;
  if (SIZE_LABELS.includes(lower)) return i18n.sizeLabel || name;
  return name.charAt(0).toUpperCase() + name.slice(1);
}

function shopifyImgUrl(src, size) {
  if (!src) return '';
  const url = /^https?:/.test(src) ? src : 'https:' + src;
  return url.replace(/(\.[^.?#]+)(\?[^#]*)?$/, `_${size}x$1$2`);
}

function getOptionName(option) {
  if (!option) return '';
  return typeof option === 'string' ? option : (option.name || String(option));
}

function findOptionIdx(options, labels) {
  if (!Array.isArray(options)) return -1;
  return options.findIndex(o => labels.includes(getOptionName(o).toLowerCase()));
}

function buildProductCard(product, wishlistItem) {
  let savedVariant = null;
  if (wishlistItem?.variantId) {
    savedVariant = product.variants.find(v => v.id === wishlistItem.variantId);
  }

  let imgSrc = shopifyImgUrl(savedVariant?.featured_image?.src || product.featured_image, 500);

  const basePrice = savedVariant ? savedVariant.price : product.price_min;
  const baseCompare = savedVariant ? savedVariant.compare_at_price : product.compare_at_price_max;
  const price = formatMoney(basePrice);
  const comparePrice = baseCompare > basePrice
    ? `<s class="price-list__item price-list__regular">${formatMoney(baseCompare)}</s>` : '';
  const priceClass = comparePrice ? 'text-on-sale' : '';

  const cartIcon = getCartIconSvg(20);
  const checkIcon = `<svg role="presentation" focusable="false" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>`;

  return `
    <div class="product-card product-card--blends">
      <div class="product-card__figure">
        <a href="${product.url}">
          ${imgSrc ? `<img src="${imgSrc}" alt="${product.title}" class="product-card__image product-card__image--primary aspect-natural" loading="lazy" width="500" height="auto">` : ''}
        </a>
        <button type="button" class="wishlist-button is-active"
          data-wishlist-toggle="${wishlistItem?.handle || product.handle}"
          data-wishlist-variant-id="${wishlistItem?.variantId || ''}"
          aria-pressed="true"
          aria-label="${i18n.remove}">
          ${heartSvg(20)}
        </button>
        <button type="button" class="wishlist-cart-button"
          data-wishlist-add-cart="${wishlistItem?.handle || product.handle}"
          data-wishlist-cart-variant="${wishlistItem?.variantId || ''}"
          data-wishlist-variant-handle="${wishlistItem?.variantHandle || ''}"
          aria-label="${i18n.addToCart}">
          <span class="wishlist-cart-button__icon">${cartIcon}</span>
          <span class="wishlist-cart-button__check" aria-hidden="true">${checkIcon}</span>
        </button>
      </div>
      <div class="product-card__info">
        <div class="v-stack gap-0.5 w-full">
          <span class="product-card__title">
            <a href="${product.url}" class="bold">${product.title}</a>
          </span>
          <div class="price-list h-stack gap-2 items-baseline">
            ${comparePrice}
            <span class="price-list__item price-list__sale ${priceClass}">${price}</span>
          </div>
        </div>
      </div>
    </div>`;
}

// ---- Add to cart ----

async function addToCartFromWishlist(variantId) {
  const sectionsToBundle = ['variant-added'];

  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
    bubbles: true,
    detail: { sections: sectionsToBundle }
  }));

  const formData = new FormData();
  formData.set('id', variantId);
  formData.set('quantity', '1');
  formData.set('sections', sectionsToBundle.join(','));
  formData.set('sections_url', `${Shopify.routes.root}variants/${variantId}`);

  try {
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) return false;

    const responseJson = await response.json();
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent['sections'] = responseJson['sections'];

    document.dispatchEvent(new CustomEvent('variant:add', {
      bubbles: true,
      detail: {
        items: Array.isArray(responseJson.items) ? responseJson.items : [responseJson],
        cart: cartContent
      }
    }));

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart: cartContent }
    }));

    return true;
  } catch {
    return false;
  }
}

function showCartButtonSuccess(handle) {
  const btn = document.querySelector(`[data-wishlist-add-cart="${handle}"]`);
  if (!btn) return;
  btn.classList.add('is-success');
  setTimeout(() => btn.classList.remove('is-success'), 2000);
}

// ---- Size picker modal ----

function showSizePickerModal(product, savedVariant, colorValue, colorIdx, sizeIdx, eligibleVariants, options, canonicalHandle) {
  document.getElementById('wishlist-size-modal')?.remove();

  const imgSrc = shopifyImgUrl(savedVariant?.featured_image?.src || product.featured_image, 300);

  const modalBasePrice = savedVariant ? savedVariant.price : product.price_min;
  const modalCompare = savedVariant ? savedVariant.compare_at_price : product.compare_at_price_max;
  const price = formatMoney(modalBasePrice);
  const comparePrice = modalCompare > modalBasePrice
    ? `<s class="price-list__item price-list__regular">${formatMoney(modalCompare)}</s>` : '';

  const opts = options || (Array.isArray(product.options) ? product.options : []);
  const colorOptionName = colorIdx >= 0 ? getOptionName(opts[colorIdx]) : null;
  const sizeOptionName = sizeIdx >= 0 ? getOptionName(opts[sizeIdx]) : null;

  const sizesHtml = eligibleVariants.map(v => {
    const label = sizeIdx >= 0 ? v[`option${sizeIdx + 1}`] : v.title;
    const disabled = !v.available;
    // Don't use the HTML `disabled` attribute — the theme CSS rule `:disabled + .block-swatch { display:none }`
    // would hide any button that immediately follows a disabled button (sibling selector).
    // We use the `is-disabled` class + `aria-disabled` instead.
    return `<button type="button" class="block-swatch wishlist-size-btn${disabled ? ' is-disabled' : ''}" data-variant-id="${v.id}" data-available="${v.available}"${disabled ? ' aria-disabled="true"' : ''}>${label}</button>`;
  }).join('');

  const modal = document.createElement('div');
  modal.id = 'wishlist-size-modal';
  modal.className = 'wishlist-size-modal';
  modal.innerHTML = `
    <div class="wishlist-size-modal__backdrop"></div>
    <div class="wishlist-size-modal__dialog" role="dialog" aria-modal="true" aria-label="${i18n.chooseSize}">
      <button type="button" class="wishlist-size-modal__close" aria-label="${i18n.close}">
        <svg focusable="false" width="16" height="16" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M1 1l16 16M17 1L1 17"/></svg>
      </button>
      <div class="quick-buy-drawer__info">
        <div class="quick-buy-drawer__variant text-start h-stack gap-6">
          ${imgSrc ? `<img src="${imgSrc}" alt="${product.title}" class="quick-buy-drawer__media rounded-xs" loading="lazy" width="80" height="auto">` : ''}
          <div class="v-stack gap-1">
            <div class="v-stack gap-0.5">
              <a href="${product.url}" class="bold justify-self-start">${product.title}</a>
              <div class="price-list h-stack gap-2 items-baseline">${comparePrice}<span class="price-list__item price-list__sale">${price}</span></div>
            </div>
            ${colorValue && colorOptionName ? `<p class="text-sm text-subdued">${localizeOption(colorOptionName)}: ${colorValue}</p>` : ''}
          </div>
        </div>
        ${sizeOptionName ? `
          <div>
            <p class="text-subdued text-sm" style="margin-bottom:var(--spacing-3)">${localizeOption(sizeOptionName)}:</p>
            <div class="variant-picker__option-values wrap gap-2">${sizesHtml}</div>
          </div>` : ''}
        <p class="wishlist-size-modal__error text-sm" hidden>${i18n.pleaseChooseSize}</p>
        <div class="buy-buttons">
          <button type="button" class="button button--lg wishlist-size-modal__add-btn" style="width:100%">${i18n.addToCart}</button>
        </div>
      </div>
    </div>`;

  document.body.appendChild(modal);
  requestAnimationFrame(() => modal.classList.add('is-open'));

  let selectedVariantId = null;

  modal.querySelectorAll('.wishlist-size-btn:not(.is-disabled)').forEach(btn => {
    btn.addEventListener('click', () => {
      modal.querySelectorAll('.wishlist-size-btn').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      selectedVariantId = parseInt(btn.dataset.variantId);
      modal.querySelector('.wishlist-size-modal__error').hidden = true;
    });
  });

  // Auto-select if only one size is available
  const available = Array.from(modal.querySelectorAll('.wishlist-size-btn:not(.is-disabled)'));
  if (available.length === 1) available[0].click();

  const addBtn = modal.querySelector('.wishlist-size-modal__add-btn');
  addBtn.addEventListener('click', async () => {
    if (!selectedVariantId) {
      modal.querySelector('.wishlist-size-modal__error').hidden = false;
      return;
    }
    addBtn.disabled = true;
    const success = await addToCartFromWishlist(selectedVariantId);
    addBtn.disabled = false;
    if (success) {
      closeWishlistModal(modal);
      showCartButtonSuccess(canonicalHandle || product.handle);
    }
  });

  modal.querySelector('.wishlist-size-modal__backdrop').addEventListener('click', () => closeWishlistModal(modal));
  modal.querySelector('.wishlist-size-modal__close').addEventListener('click', () => closeWishlistModal(modal));

  const onEsc = e => {
    if (e.key === 'Escape') { closeWishlistModal(modal); document.removeEventListener('keydown', onEsc); }
  };
  document.addEventListener('keydown', onEsc);
}

function closeWishlistModal(modal) {
  modal.classList.remove('is-open');
  setTimeout(() => { if (modal.isConnected) modal.remove(); }, 300);
}

// ---- Cart button click handler (event delegation) ----

document.addEventListener('click', e => {
  const btn = e.target.closest('[data-wishlist-add-cart]');
  if (!btn) return;
  e.preventDefault();
  handleWishlistCartClick(btn.dataset.wishlistAddCart, btn);
});

async function handleWishlistCartClick(productHandle, triggerBtn) {
  if (triggerBtn) triggerBtn.style.opacity = '0.6';

  try {
    const cartVariantId = triggerBtn?.dataset.wishlistCartVariant
      ? parseInt(triggerBtn.dataset.wishlistCartVariant) || null
      : null;
    const variantHandle = triggerBtn?.dataset.wishlistVariantHandle || null;
    const wishlistItem = cartVariantId
      ? { handle: productHandle, variantId: cartVariantId, variantHandle }
      : Wishlist.getItem(productHandle);

    // For combined listings, fetch the color-specific product if a variantHandle is stored
    const fetchHandle = wishlistItem?.variantHandle || variantHandle || productHandle;
    const product = await fetchProduct(fetchHandle);

    if (!product) {
      if (triggerBtn) triggerBtn.style.opacity = '';
      return;
    }

    const options = Array.isArray(product.options) ? product.options : [];
    const colorIdx = findOptionIdx(options, COLOR_LABELS);
    const sizeIdx = findOptionIdx(options, SIZE_LABELS);

    const variantIdProvided = !!wishlistItem?.variantId;
    let savedVariant = variantIdProvided
      ? product.variants.find(v => v.id === wishlistItem.variantId)
      : null;
    const variantFoundInProduct = !!savedVariant;

    if (!savedVariant) {
      savedVariant = product.variants.find(v => v.available) || product.variants[0];
    }

    // Only filter by color if the saved variant was actually found in this product.
    // If variantId was given but not found (e.g. old wishlist entry without variantHandle),
    // skip the color filter to avoid showing a wrong/incomplete subset of sizes.
    const applyColorFilter = variantFoundInProduct || !variantIdProvided;
    const colorValue = (applyColorFilter && colorIdx >= 0 && savedVariant)
      ? savedVariant[`option${colorIdx + 1}`]
      : null;

    let eligibleVariants = product.variants;
    if (colorValue && colorIdx >= 0) {
      eligibleVariants = product.variants.filter(v => v[`option${colorIdx + 1}`] === colorValue);
    }
    if (!eligibleVariants.length) eligibleVariants = product.variants;


    if (triggerBtn) triggerBtn.style.opacity = '';

    // No size picker needed for single-variant or no-size-option products
    if (sizeIdx < 0 || eligibleVariants.length <= 1) {
      const target = eligibleVariants.find(v => v.available) || eligibleVariants[0];
      if (!target) return;
      const success = await addToCartFromWishlist(target.id);
      if (success) showCartButtonSuccess(productHandle);
      return;
    }

    showSizePickerModal(product, savedVariant, colorValue, colorIdx, sizeIdx, eligibleVariants, options, productHandle);
  } catch (err) {
    if (triggerBtn) triggerBtn.style.opacity = '';
    console.error('[Wishlist] Fehler beim Öffnen des Warenkorbs:', err);
  }
}

// ---- Wishlist page rendering ----

async function renderWishlistPage() {
  const container = document.querySelector('[data-wishlist-page]');
  if (!container) return;

  const items = Wishlist.getAll();

  if (items.length === 0) {
    container.innerHTML = `<div class="wishlist-empty v-stack items-center gap-6 text-center"><p>${i18n.empty}</p><a href="/collections/all" class="button button--xl">${i18n.shopNow}</a></div>`;
    return;
  }

  container.innerHTML = `<div class="wishlist-loading">${i18n.loading}</div>`;

  // For combined listings, fetch the color-specific product when a variantHandle is stored
  const products = await Promise.all(items.map(item => fetchProduct(item.variantHandle || item.handle)));
  const valid = products.reduce((acc, p, i) => {
    if (p) acc.push({ product: p, wishlistItem: items[i] });
    return acc;
  }, []);

  if (valid.length === 0) {
    Wishlist.save([]);
    container.innerHTML = `<div class="wishlist-empty v-stack items-center gap-6 text-center"><p>${i18n.empty}</p><a href="/collections/all" class="button button--xl">${i18n.shopNow}</a></div>`;
    return;
  }

  container.innerHTML = `
    <ul class="product-list wishlist-grid" role="list">
      ${valid.map(({ product, wishlistItem }) => `<li>${buildProductCard(product, wishlistItem)}</li>`).join('')}
    </ul>`;

  initWishlistButtons();
}

function initAll() {
  initWishlistButtons();
  updateCountBubbles();
  if (document.querySelector('[data-wishlist-page]')) renderWishlistPage();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
